import { Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ErrorPage(props: { message?: string; hideButton?: boolean }) {
  return (
    <Grid container height='100vh' alignItems='center' justifyContent='center' direction='column'>
      <h2>{props.message || 'Uh oh! Looks like we experienced a problem :('}</h2>
      <Link to='/'>
        {!props.hideButton && (
          <Button variant='contained' component='label'>
            Go Home
          </Button>
        )}
      </Link>
    </Grid>
  );
}
